import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";

// The one place that names the MCP host; every Bezirk runs on it, the Bezirk travels in the token.
export const VOLT_API_BASE = (
  import.meta.env.VITE_VOLT_API_BASE || "https://volt-crm-mcp-tsuzs.sevalla.app"
).replace(/\/+$/, "");

export class VoltApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code?: string,
  ) {
    super(message);
    this.name = "VoltApiError";
  }
}

const accessToken = async (): Promise<string | null> => {
  const { data } = await getSupabaseClient().auth.getSession();
  return data.session?.access_token ?? null;
};

/** JSON request against the MCP with the CRM session as bearer token. */
export const voltFetch = async <T>(
  path: string,
  init: RequestInit = {},
): Promise<T> => {
  const token = await accessToken();
  const res = await fetch(`${VOLT_API_BASE}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init.headers,
    },
  });
  if (!res.ok) {
    let message = String(res.status);
    let code: string | undefined;
    try {
      const body = await res.json();
      message = body?.error ?? message;
      code = body?.code;
    } catch {
      // no JSON body
    }
    throw new VoltApiError(message, res.status, code);
  }
  return res.json() as Promise<T>;
};
